/** 選択できる連携入力項目か */
export const isInputSelectable = (record: { state: number }) => {
  return record.state === 0 || record.state === 2;
};
